/**
 * Created by rhinov8e on 20/11/2015.
 *
 * UI State when an entity (arrangement object, technical element, stair etc) is updated
 */

import { UiState, UiStateEnum } from "./UiState";
import { ActionStateEnum } from "../actionState/ActionState";
import { GameObjectManager } from "../../plan/GameObjectManager";
import { PlanManager } from "../../../../cocosPlan";
import { AddEntityState } from "../actionState/AddEntityState";
import { Entity, math, roomManager } from "@rhinov/savane-js";

export class EntityDimensionState extends UiState {

    entity: Entity | null = null;

    constructor(cursorPosition: math.vec3, cocosPosition: math.vec3) {
        super(cursorPosition, cocosPosition);
        // Check current action and retrieve the entity to edit
        switch (PlanManager.getInstance().state.getAction()) {
            // Add, edit a generic entity
            case ActionStateEnum.EditEntity:
            case ActionStateEnum.AddEntity:
                this.entity = (PlanManager.getInstance().state as AddEntityState).entity;
                break;

            // // Technical element edition
            // case ActionStateEnum.EditTechnicalElement:
            //     this.entity = (PlanManager.getInstance().state as EditEntityState)._editedTech;
            //     break;

            // // Technical element addition
            // case ActionStateEnum.AddTechnicalElement:
            //     this.entity = (PlanManager.getInstance().state as AddEntityState).techElement;
            //     break;

            // // Stair edition
            // case ActionStateEnum.EditStaircase:
            //     this.entity = PlanManager.getInstance().state._editedStair;
            //     break;

        //     // Stair addition
        //     case ActionStateEnum.AddStaircase:
        //         this.entity = PlanManager.getInstance().state.staircase;
        //         break;
        }
    }

    // Return value from gloabl enum
    getUiState(): number {
        return UiStateEnum.uiEntityDimension;
    }

    // The mouse is moving in this state
    moveMouseCursor(cursorPosition: math.vec3, cocosPos: math.vec3): UiState | null {
        // Store cursor and cocos cursor positions
        this.cursorPosition = cursorPosition;
        this.cocosPosition = cocosPos;

        // If next ui state === current state and entity object to update exists
        if (this.getNextUiState() === this.getUiState() && this.entity !== null && this.entity !== undefined) {
            // Update its dimensions and leave without changing the state for next loop
            this.updateDimensions();
            return null;
        }
        else {
            // Remove dimensions displayed around the arrangement object
            GameObjectManager.deleteObjectAroundDimension();
            // Create next Ui state for next loop and return it for activation
            return this.createNextUiState();
        }
    }

    // Called when the mouse is moving or a key is pressed to update arrangement dimensions within a room displayed on scree
    updateDimensions() {
        // Check if the arrangement is in a room
        var room = roomManager.getRoomAtPosition(this.entity!.position, PlanManager.getInstance().world.currentScene!.currentFloor!);
        if (room !== null) {
            // Yes, draw dimensions for the room around the object (managed by game object manager)
            GameObjectManager.drawObjectAroundDimension(this.entity, room);
        }
        else {
            // No, delete the dimensions around the object
            GameObjectManager.deleteObjectAroundDimension();
        }
    }

    // Called when a key is pressed in this state
    keyPressed(keyCode: number): UiState | null {
        this.updateDimensions();
        return null;
    }
}